import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { LAYER_ID_CMM, LAYER_ID_POLYLINE } from '../../store/map/map.constants'
import { selectActiveMapEvents, selectIsMapInitialized } from '../../store/map/map.selectors'
import { selectIsFrenchSite } from '../../store/navigation/navigation.selectors'
import { selectQuizGuessInProgress } from '../../store/quiz/quiz.selectors'
import { isGE } from '../Device'
import { getBBoxAroundPointer } from '../utils/map'
import useErrorBoundaryCallback from '../utils/useErrorBoundaryCallback'
import { useMapContext } from './MapContext'

const useMapPointerHandler = () => {
  const { map } = useMapContext()
  const mapInitialized = useSelector(selectIsMapInitialized)
  const isFrenchSite = useSelector(selectIsFrenchSite)
  const quizGuessInProgress = useSelector(selectQuizGuessInProgress)
  const activeMapEvents = useSelector(selectActiveMapEvents)
  const mapEventsKeys = activeMapEvents.map(({ key }) => key)

  const getPolylinesOrClickableLayersAroundPointer = useErrorBoundaryCallback(
    event =>
      map.queryRenderedFeatures(getBBoxAroundPointer(event)).find(feature => {
        const layerId = feature.layer?.id ?? ''
        const polyline = LAYER_ID_POLYLINE.test(layerId)
        const cmm = isFrenchSite ? LAYER_ID_CMM.test(layerId) : false
        const isMapEvent = mapEventsKeys.find(key => layerId.includes(key))
        return polyline || cmm || isMapEvent
      }),
    [map, isFrenchSite, mapEventsKeys]
  )

  const handleMouseOver = useErrorBoundaryCallback(
    e => {
      const shouldDisplayPointer = getPolylinesOrClickableLayersAroundPointer(e)
      if (shouldDisplayPointer) {
        map.getCanvas().style.cursor = 'pointer'
      } else if (quizGuessInProgress) {
        map.getCanvas().style.cursor = 'crosshair'
      } else {
        map.getCanvas().style.cursor = ''
      }
    },
    [map, getPolylinesOrClickableLayersAroundPointer, quizGuessInProgress]
  )

  useEffect(() => {
    if (isGE()) {
      if (map && mapInitialized) map.on('mousemove', handleMouseOver)
      return () => {
        if (map) map.off('mousemove', handleMouseOver)
      }
    }
  }, [map, mapInitialized, handleMouseOver])
}

export default useMapPointerHandler
